<template>
  <div class="top">
    <router-link to="./">
     <img
        class="logo"
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/logo.png"
        alt=""
      />
    </router-link>

    <div class="nav">
      <router-link to="./serve">
        <p>定制服务</p>
      </router-link>
      <router-link to="./solve">
        <p>解决方案</p>
      </router-link>
      <router-link to="./case">
        <p>案例</p>
      </router-link>

      <p @click="toAbout">关于</p>

      <!-- <p @click="toConsult">联系</p> -->
	  <a href="https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn" target="_blank">联系</a>
    </div>
    <div class="address">
<!--      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/address.png"
        alt=""
      /> -->
      <!-- <div @click="checked" class="addressName">上海</div> -->
		<a href="https://www.junhebrand.com" target="_blank">总站</a>
      <!-- <div v-if="isZzShow" class="zz">
        <ul>
          <li @click="toSh">上海</li>
          <li @click="toZz">郑州</li>
        </ul>
      </div> -->
    </div>
  </div>
</template>


<script>
import Vue from "vue";
export default {
  name: "Nav",
  data() {
    return {
      isZzShow: false,
    };
  },
  methods: {
    // toConsult() {
    //   window.open(
    //     "https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn&e=%e5%bc%b9%e7%aa%97",
    //     "_blank"
    //   );
    // },
    checked() {
      this.isZzShow = !this.isZzShow;
    },
    toSh() {
      window.open("http://applet.junhebrand.com/sh/#/", "_blank");
      this.isZzShow = false;
    },
    toZz() {
      window.open("http://applet.junhebrand.com/zz/#/", "_blank");
      this.isZzShow = false;
    },
    toAbout() {
      window.open("https://www.junhebrand.com/about", "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  width: 1440px;
  height: 88px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .logo {
    display: block;
    width: 110px;
    height: 36px;
  }

  .nav {
    width: 692px;
    height: 24px;
    line-height: 24px;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #ffffff;
    

    p {
      display: block;
      height: 24px;
      line-height: 24px;
      color: #ffffff;
      font-size: 16px;
      font-weight: 400;
    }
    p:hover {
      color: red;
      cursor: pointer;
    }
	
	a {
	  display: block;
	  height: 24px;
	  line-height: 24px;
	  color: #ffffff;
	  font-size: 16px;
	  font-weight: 400;
	}
	a:hover {
	  color: red;
	  cursor: pointer;
	}
  }
  .address {
    position: relative;
    width: 70px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 16px;
    color: #ffffff;
    font-weight: 400;
	a{
		color: #FFFFFF;
	}
    .zz {
      position: absolute;
      width: 82px;
      height: 102px;
      background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/xialabg.png)
        no-repeat;
      background-size: cover;
      border-radius: 3px;
      box-shadow: 2px 2px 5px 5px rgba(3, 3, 3, 0.221);
      top: 28px;
      z-index: 999;
      ul {
        width: 100%;
        height: 100%;
        li {
          color: #ffffff;
          width: 100%;
          height: 50px;
          line-height: 50px;
          font-size: 16px;
          text-align: center;
        }
        li:hover {
          background: #fd8b8b;
          cursor: pointer;
          color: aliceblue;
          border-radius: 5px;
        }
      }
    }
    img {
      display: block;
      width: 24px;
      height: 24px;
    }
    div,
    .xiala {
      // cursor: pointer;
    }
  }
}
</style>